

const base_url = process.env.NEXT_PUBLIC_BASE_URL

export const ADD_ADDRESS_API = `${base_url}/api/user/address/add`
export const EDIT_ADDRESS_API = `${base_url}/api/user/address/update`
export const DELETE_ADDRESS_API = `${base_url}/api/user/address/remove`
export const GET_ADDRESSES_API = `${base_url}/api/user/address/get`
export const DEFAULT_ADDRESS_API = `${base_url}/api/user/address/set-default`
export const GET_ONGOING_ORDERS = `${base_url}/api/order/ongoing`
export const CANCEL_ORDER = `${base_url}/api/order`
export const GET_COMPLETED_ORDERS = `${base_url}/api/order/completed`
export const GET_CANCELLED_ORDERS = `${base_url}/api/order/cancelled`
export const GET_ORDER = `${base_url}/api/order`




